import React, { useState, useEffect } from "react";
import { BsSunriseFill, BsSunsetFill } from "react-icons/bs";
import performRequest from "../../api/request";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import { Toast } from "../../CustomComponent/toast";
import { socket } from "../../api/socket.io";
import { useLocation, useNavigate } from "react-router";

function formatToIndianNumberingSystem(number) {
  const formatter = new Intl.NumberFormat("en-IN", {
    maximumFractionDigits: 0,
  });
  return formatter.format(number);
}

function FooterwithoutLogin() {
  const [data, setData] = useState();
  const location = useLocation();
  const navigate = useNavigate();
  const themeKey = "tablerTheme";
  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    const excludedPage = "/hydroponic-material-planning/table"; // Page without theme
    const excludedPage2 = "/employee-payslip";

    if (
      location.pathname === excludedPage ||
      location.pathname === excludedPage2
    ) {
      document.body.removeAttribute("data-bs-theme");
      return;
    }

    let theme =
      new URLSearchParams(location.search).get("theme") ||
      localStorage.getItem(themeKey) ||
      "light";

    setIsDarkMode(theme === "dark");
    localStorage.setItem(themeKey, theme);

    document.body.setAttribute("data-bs-theme", theme);

    // Update URL only if theme is missing from the query
    if (!new URLSearchParams(location.search).get("theme")) {
      const params = new URLSearchParams(location.search);
      params.set("theme", theme);
      navigate(`${location.pathname}?${params.toString()}`, { replace: true });
    }
  }, [location.pathname, location.search, navigate]);

  const toggleTheme = () => {
    const newTheme = isDarkMode ? "light" : "dark";
    setIsDarkMode(!isDarkMode);
    localStorage.setItem(themeKey, newTheme);

    if (
      location.pathname !== "/hydroponic-material-planning/table" ||
      location.pathname !== "/employee-payslip"
    ) {
      document.body.setAttribute("data-bs-theme", newTheme);
    }

    const params = new URLSearchParams(location.search);
    params.set("theme", newTheme);
    navigate(`${location.pathname}?${params.toString()}`, { replace: true });
  };

  useEffect(() => {
    performRequest("GET", "/cultivation/getTotalCultivation/")
      .then((res) => {
        if (res.status === 200) {
          setData(res.data?.totalArea);
        } else {
          Toast("error", "Error while getting Leads!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);

  useEffect(() => {
    socket.on("getCultivation", (getCultivation) => {
      setData(getCultivation);
    });

    return () => {
      socket.off("getCultivation"); // Clean up on unmount
    };
  }, [socket]);

  const [currentDateTime, setCurrentDateTime] = useState({
    date: "",
    time: "",
  });

  const getDateTime = (date) => {
    const formattedTime = date.toLocaleTimeString("en-US", {
      hour12: true,
      hour: "numeric",
      minute: "2-digit",
      second: "2-digit",
    });
    const formattedDate = `${
      date.getMonth() + 1
    }/${date.getDate()}/${date.getFullYear()}`;
    setCurrentDateTime({ date: formattedDate, time: formattedTime });
  };

  useEffect(() => {
    const initialDate = new Date();
    getDateTime(initialDate);
    const intervalId = setInterval(() => {
      const currentDate = new Date();
      getDateTime(currentDate);
    }, 1000);
    return () => clearInterval(intervalId);
  }, []);

  return (
    <>
      <footer
        className="text-white pt-5 pb-4 mt-5"
        style={{ backgroundColor: "#1f2937" }}
      >
        <div className="container">
          <div className="row gy-4 justify-content-between align-content-between px-lg-5 px-0">
            {/* Brand Section */}
            <div className="col-md-4 ps-4">
              <div>
                <h4 className="fw-bold mb-3 fs-3 text-uppercase text-md-start text-lg-start text-center text-white">
                  Kryzen Biotech Pvt Ltd.
                </h4>
                <div className="mb-3 text-md-start text-lg-start text-center">
                  {!(
                    location.pathname ===
                      "/hydroponic-material-planning/table" ||
                    location.pathname === "/employee-payslip"
                  ) && (
                    <button
                      className="btn btn-sm btn-outline"
                      onClick={toggleTheme}
                    >
                      {isDarkMode ? (
                        <BsSunriseFill className="fs-3 me-2" />
                      ) : (
                        <BsSunsetFill className="fs-3 me-2" />
                      )}
                      Switch to {isDarkMode ? "Light" : "Dark"} Mode
                    </button>
                  )}
                </div>
                <div className="text-md-start text-lg-start text-center">
                  <span className="text-white text-decoration-none hovereffect ">
                    Total hydroponic cultivation
                  </span>
                </div>

                <div className="text-md-start text-lg-start text-center">
                  <b
                    className="text-white text-decoration-none hovereffect text-md-start text-lg-start text-center"
                    style={{ fontSize: "30px" }}
                  >
                    {formatToIndianNumberingSystem(data)}{" "}
                    <span className="text-white text-decoration-none hovereffect">
                      sqft
                    </span>
                  </b>
                </div>

                <div className="text-md-start text-lg-start text-center">
                  <span className="text-white text-decoration-none hovereffect">
                    {currentDateTime.date} {currentDateTime.time}
                  </span>
                </div>

                <div className="text-md-start text-lg-start text-center">
                  <a
                    href="/request-refund"
                    className="text-white text-decoration-none hovereffect text-md-start text-lg-start text-center"
                  >
                    Request a Refund
                  </a>
                </div>

                <div className="text-md-start text-lg-start text-center">
                  {" "}
                  <a href="https://res.cloudinary.com/bsgfcooa/image/upload/v1752563919/Kryzen-Brochure-2025_compressed-2_qlxwzm.pdf">
                    <button className="btn btn-success mt-2 btn-sm">
                      Download Brochure
                    </button>
                  </a>
                </div>
              </div>
            </div>

            {/* Product Links */}
            <div className="col-md-4 d-md-flex justify-content-md-center align-content-md-center ps-4 ps-md-0 ps-lg-0">
              <div>
                <h5 className="fw-semibold mb-3 fs-3 text-uppercase text-md-start text-lg-start text-center text-white">
                  Our Products
                </h5>
                <ul className="list-unstyled">
                  <li className="mb-2 text-md-start text-lg-start text-center">
                    <a
                      href="/kryzen-naturally-ventilated-polyhouse"
                      className="text-white text-decoration-none hovereffect"
                    >
                      Naturally Ventilated Polyhouse
                    </a>
                  </li>
                  <li className="mb-2 text-md-start text-lg-start text-center">
                    <a
                      href="/kryzen-nethouse-shadehouse"
                      className="text-white text-decoration-none hovereffect"
                    >
                      Net House / Shade House
                    </a>
                  </li>
                  <li className="mb-2 text-md-start text-lg-start text-center">
                    <a
                      href="/kryzen-exhaust-fan-pad-controlled-environment-polyhouse"
                      className="text-white text-decoration-none hovereffect"
                    >
                      Fan & Pad Polyhouse
                    </a>
                  </li>
                  <li className="mb-2 text-md-start text-lg-start text-center">
                    <a
                      href="/kryzen-flat-nft-hydroponics"
                      className="text-white text-decoration-none hovereffect"
                    >
                      Flat NFT Hydroponics
                    </a>
                  </li>
                  <li className="mb-2 text-md-start text-lg-start text-center">
                    <a
                      href="/kryzen-dutch-buckets"
                      className="text-white text-decoration-none hovereffect"
                    >
                      Dutch Bucket System
                    </a>
                  </li>
                  <li className="mb-2 text-md-start text-lg-start text-center">
                    <a
                      href="/kryzen-for-soil-less-growing"
                      className="text-white text-decoration-none hovereffect"
                    >
                      Grow Bags System
                    </a>
                  </li>
                  <li className="mb-2 text-md-start text-lg-start text-center">
                    <a
                      href="/kryzen-a-frame"
                      className="text-white text-decoration-none hovereffect"
                    >
                      A-Frame System
                    </a>
                  </li>
                  {/* <li className="mb-2">
                  <a
                    href="#"
                    className="text-white text-decoration-none hovereffect"
                  >
                    Grow Slab System
                  </a>
                </li> */}
                </ul>
              </div>
            </div>

            {/* Company Links */}
            <div className="col-md-4 d-md-flex justify-content-md-center align-content-md-center ps-4 ps-md-0 ps-lg-0">
              <div>
                <h5 className="fw-semibold mb-3 fs-3 text-uppercase text-md-start text-lg-start text-center text-white">
                  About Company
                </h5>
                <ul className="list-unstyled">
                  <li className="mb-2 text-md-center text-md-start text-lg-start text-center">
                    <a
                      href="/why-kryzen-biotech"
                      className="text-white text-decoration-none hovereffect "
                    >
                      Why Kryzen Biotech
                    </a>
                  </li>
                  <li className="mb-2 text-md-start text-lg-start text-center">
                    <a
                      href="/kryzen-software-services"
                      className="text-white text-decoration-none hovereffect "
                    >
                      Software Services
                    </a>
                  </li>
                  <li className="mb-2 text-md-start text-lg-start text-center">
                    <a
                      href="/kryzen-agronomy-support"
                      className="text-white text-decoration-none hovereffect"
                    >
                      Agronomy Support
                    </a>
                  </li>
                  <li className="mb-2 text-md-start text-lg-start text-center">
                    <a
                      href="/kryzen-quotation-explainer"
                      className="text-white text-decoration-none hovereffect"
                    >
                      Quotation Explainer
                    </a>
                  </li>
                  <li className="mb-2 text-md-start text-lg-start text-center">
                    <a
                      href="#"
                      className="text-white text-decoration-none hovereffect"
                    >
                      Kryzen Office & Farm
                    </a>
                  </li>
                  <li className="mb-2 text-md-start text-lg-start text-center">
                    <a
                      href="/kryzen-employee-tranning"
                      className="text-white text-decoration-none hovereffect"
                    >
                      Employee Training Programme
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <hr />
            <div className="container">
              <div className="row text-center">
                <div className="col-12 col-md-12">
                  <div className="d-flex flex-column flex-md-row justify-content-center align-items-center mb-2">
                    <p className="mb-2 mb-md-0 me-md-3">
                      <span>CIN: U01100PN2019PTC186207</span>
                    </p>
                    <p className="mb-2 mb-md-0 me-md-3">GST: 27AAHCK7659R1ZF</p>
                    <p className="mb-2 mb-md-0">
                      Contact:{" "}
                      <a
                        href="tel:+919870424425"
                        className="text-white text-decoration-none hovereffect"
                      >
                        +91-9870424425
                      </a>
                    </p>
                  </div>
                  <p className="mb-1">
                    Copyright &copy; 2019 - 2026{" "}
                    <a
                      className="text-white"
                      style={{ color: "#6c7a91" }}
                      href="https://share.google/cXN1DfEQzRdEuoTD3"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Kryzen Biotech Pvt Ltd.
                    </a>
                  </p>
                  <p className="mb-0 text-decoration-none">
                    🇮🇳 Product of India. Developed for the World. 🌍
                  </p>
                  <p className="mb-0 text-decoration-none mt-1">
                    <span>
                      <a href="/terms-condition" className="text-white">
                        Terms & Conditions
                      </a>
                    </span>{" "}
                    -&nbsp;
                    <span>
                      <a href="/privacy-policy" className="text-white">
                        Privacy-Policy
                      </a>
                    </span>{" "}
                    -&nbsp;
                    <span>
                      <a href="/refund-policy" className="text-white">
                        Refund Policy
                      </a>
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default FooterwithoutLogin;
